import React, { useState } from "react";
import { getNewsData } from "../api/home";
import { useTranslation } from "react-i18next";
import { CiSearch } from "react-icons/ci";
import NewsCard from "../components/NewsCard";
import PageContainer from "../components/PageContainer";
import "../styles/news.css";

const searchListRelated = [
  { name: "ประกาศจัดซื้อจัดจ้าง" },
  { name: "กิจกรรม" },
  { name: "ประชุมลประจำปี" },
  { name: "สกมช" },
];

const Search = () => {
  const [isSearch, setIsSearch] = useState(false);

  const { t, i18n } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [news, setNews] = useState([]);
  const [otherNews, setOtherNews] = useState([]);

  const [submitSearch, setSubmitSearch] = useState(false);

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = async (searchTerm) => {
    try {
      // event?.preventDefault();
      setSubmitSearch(true);

      const resp = await getNewsData();

      const filter = resp.filter((item) => {
        return item.title.toLowerCase().includes(searchTerm.toLowerCase());
      });

      const ncsa = filter.filter((item) => item.category.includes("news"));
      const oths = filter.filter((item) => !item.category.includes("news"));

      setNews(ncsa);
      setOtherNews(oths);
    } catch (error) {
      console.warn(error);
    }
  };

  return (
    <>
      <main className={`site-main pb-10  min-h-[1000px]`}>
        <section>
          <div className="site-search">
            <div className="pt-32 w-full bg-gradient-to-b from-blue-900 to-white text-center py-4 h-56">
              <div className="flex items-center justify-center">
                <div className="w-1/4 h-0.5 bg-blue-600"></div>
                <h2 className="text-blue-600 text-2xl font-semibold mx-4">
                  Search
                </h2>
                <div className="w-1/4 h-0.5 bg-blue-600"></div>
              </div>
            </div>
            <div className="container mx-auto ">
              <div className="search-bar">
                <form
                  onSubmit={(ev) => {
                    ev.preventDefault();
                    handleSubmit(inputValue);
                  }}
                  className="search-bar-form"
                >
                  <div className="search-bar-group">
                    <CiSearch className="search-bar-icon" />
                    <input
                      type="text"
                      id="searchText"
                      value={inputValue}
                      onChange={handleChange}
                      className="search-bar-input"
                    />
                  </div>
                  <button type="submit" className="button-red-main text-md">
                    {t("search")}
                  </button>
                </form>
              </div>
              <div className="search-related">
                <h3 className="search-related-header">{t("searchRelated")}</h3>
                <div className="search-related-popular">
                  {searchListRelated.map((item, index) => (
                    <button
                      key={index}
                      className="button-chip text-md"
                      onClick={() => {
                        setInputValue(item.name);
                        handleSubmit(item.name);
                      }}
                    >
                      {item.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            {submitSearch && (
              <div className="container mx-auto ">
                <div className="news-container">
                  <h4 className="news-title text-xl">ข่าว สกมช.</h4>
                  <div
                    className="flex flex-wrap"
                    onClick={() => setIsSearch(false)}
                  >
                    {news.length ? (
                      news.map((el) => (
                        <NewsCard
                          key={el?._id}
                          url={`/news/${el?._id}`}
                          title={el?.title}
                          image={
                            el?.newsimage?.path ??
                            "https://via.placeholder.com/270x150"
                          }
                          datetime={new Date(el?.showdate).getTime()}
                        />
                      ))
                    ) : (
                      <div className="">
                        <h4 className="ms-5 text-xl text-neutral-700">
                          ไม่พบข้อมูล
                        </h4>
                      </div>
                    )}
                  </div>
                </div>

                {!!otherNews.length && (
                  <div className="news-container">
                    <h4 className="news-title text-xl">
                      ข่าว อื่น ๆ ที่น่าสนใจ
                    </h4>
                    <div
                      className="flex flex-wrap"
                      onClick={() => setIsSearch(false)}
                    >
                      {otherNews.map((el) => (
                        <NewsCard
                          key={el?._id}
                          url={`/news/${el?._id}`}
                          title={el?.title}
                          image={
                            el?.newsimage?.path ??
                            "https://via.placeholder.com/270x150"
                          }
                          datetime={new Date(el?.showdate).getTime()}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default Search;
